import React from 'react';
import PropTypes from 'prop-types';

//styles
import { Input, CheckboxWrapper, CheckBox } from './Checkbox.styled';

const Checkbox = ({ name, error, description, disabled, value }) => {
  return (
    <CheckboxWrapper disabled={disabled}>
      {description}
      <Input type="checkbox" name={name} value={value} disabled={disabled} />
      <CheckBox error={error ? 'hasError' : 'noError'} />
    </CheckboxWrapper>
  );
};

Checkbox.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  error: PropTypes.bool,
  description: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
};

export default Checkbox;
